import React, { useEffect, useRef, useState } from 'react';
import store from './store';
import { observer } from 'mobx-react-lite';
import { Checkbox, Dialog, message } from '@tencent/spaui';
import Form from './form';
import { post } from 'store/request';
import dialog from 'utils/dialog';

// const baseState = {
//   target: 3, // 需求目标
//   type: 4, // 需求类型
//   budget: '100', // 预算金额
//   content: '1 . asdfa的撒范德萨发阿斯顿发\n2. 阿斯顿发送到发\n3. 阿斯顿发撒的\n4. 阿斯顿发', // 需求详情
//   tender_expect_deadline: '2032-09-28 00:00:00', // 服务商投标截止时间
//   tender_expect_num: 3, // 参与投标服务商数量
//   company_name: '公司名称', // 公司名称
//   company_brand: '产品/品牌线', // 产品/品牌线
//   company_industry: 21474836485, // 所属行业
//   company_location: 110100, // 公司所在地
//   contact_name: '用户名称', // 用户名称
//   contact_telephone: 18514203861, // 手机号码
//   code: '123341', // 验证码
//   contact_email: '123@32.com', // 邮箱
//   contact_address: '联系人地址', // 联系人地址
// };

const App = () => {
  const formRef = useRef();
  const [initData, setInitData] = useState(null);
  const [read, setRead] = useState(false);

  const { show, closeEffect, type, id, customerView } = store;

  const handleClose = () => {
    store.resetData();
    if (closeEffect) {
      closeEffect();
      // store.setCloseEffect(null);
    }
  };

  const handleSubmit = () => {
    if (type === 'disabled') {
      handleClose();
      return;
    }
    const formData = formRef.current.submit();
    if (!formData) {
      return;
    }
    if (id) {
      dialog
        .confirm('确定编辑需求吗，编辑后需重新审核')
        .then(() => {
          post(`/demand/edit/${id}`, formData, 'v2').then(() => {
            message.success('编辑需求成功');
            handleClose();
          });
        })
        .catch(() => {});
      return;
    }
    if (!id) {
      post('/demand/publish/', formData, 'v2').then(() => {
        message.success('发布需求成功');
        handleClose();
      });
    }
  };

  useEffect(() => {
    if (!show) {
      return;
    }
    setRead(false);
    if ((type === 'edit' || type === 'disabled') && id) {
      setInitData(null);
      // 需求广场客户视角
      if (!!customerView) {
        post(`/demand/square/detail/${id}`, {}, 'v2').then((res) => {
          setInitData(res);
        });
      } else {
        post(`/demand/detail/${id}`, {}, 'v2').then((res) => {
          setInitData(res);
        });
      }
      // setInitData(baseState);
      return;
    }
    if (type === 'create') {
      setInitData(null);
      // setInitData(baseState);
    }
  }, [show, type, id]);

  let title = '发布免费需求';
  if (id) {
    title = type === 'edit' ? '编辑需求' : '查看需求';
  }

  console.log('type', type);

  return (
    <Dialog
      disabled={!read}
      position="right"
      animation
      animationName="smoothIn"
      className="with-full-height"
      show={show}
      onClose={handleClose}
      onSubmit={handleSubmit}
      onCancel={handleClose}
      title={title}
      submitButton={type !== 'disabled'}
      footerStyle={{
        textAlign: 'center',
      }}
    >
      <Form ref={formRef} disabled={type === 'disabled'} id={id} isCustomerView={!!customerView} initData={initData} />
      {type !== 'disabled' && (
        <Checkbox
          style={{ display: 'block', textAlign: 'center' }}
          checked={read}
          onChange={() => {
            setRead(!read);
          }}
        >
          已阅读并同意
          <a href="https://isv.e.qq.com/license01.pdf" target="_blank" rel="noreferrer">
            《腾讯广告营销服务市场用户服务协议》
          </a>
        </Checkbox>
      )}
    </Dialog>
  );
};

export default observer(App);
